<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('reportemaquinaridiarios')">Reporte DIARIO</inertia-link>
      <span class="text-indigo-400 font-medium">/</span>Agregar
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
           <label class="pr-6 pb-8">Fecha:</label>
        <Datepicker  v-model="form.fecha" :error="form.errors.fecha" class="pr-6 pb-8 w-full lg:w-6/6" format="YYYY-MM-DD H:i:s" required/>
        
        <div class="container pb-8 pr-6 w-full lg:w-2/6">
            <label class="form-label" >Maquinaria:</label>
            <v-select v-model="form.maquinaria_id" :options="maquinarias" value="id" label="placas"></v-select>
            </div>
       
            <div class="container pb-8 pr-6 w-full lg:w-2/6">
            <label class="form-label" >Proyecto:</label>
            <v-select v-model="form.proyecto" :options="proyectos" value="id" label="nombre"></v-select>
            </div>
            <div class="container pb-8 pr-6 w-full lg:w-2/6">
            <label class="form-label" >Operador:</label>
            <v-select v-model="form.operador" :options="conductores" value="id" label="nombres"></v-select>
            </div>
          <text-input v-model="form.numero_comprobante" :error="form.errors.numero_comprobante" class="pr-6 pb-8 w-full lg:w-1/5" label="Nº Comprob." required/>
          <text-input v-model="form.hora_inicio" :error="form.errors.hora_inicio" class="pr-6 pb-8 w-full lg:w-1/5" label="Hora Inicio" required/>
          <text-input v-model="form.hora_fin" :error="form.errors.hora_fin" class="pr-6 pb-8 w-full lg:w-1/5" label="Hora Fin" required/>
          <select-input v-model="form.feriado" :error="form.errors.feriado" class="pr-6 pb-8 w-full lg:w-1/5" label="Hora Doble">
            <option>SI</option>
            <option>NO</option>
          </select-input>
          
          <text-input v-model="form.odometro_actual" :error="form.errors.odometro_actual" class="pr-6 pb-8 w-full lg:w-1/5" label="Odometro" required/>
          <text-input v-model="form.observacion" :error="form.errors.observacion" class="pr-6 pb-8 w-full lg:w-1/1" label="Observación" />
         <br><br><br><br><br>
          </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">Agregar Reporte Diario</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import Datepicker from 'vuejs-datetimepicker'
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  metaInfo: { title: 'Add  Diario Maquinaria' },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
     Datepicker,
     vSelect,
  },
  layout: Layout,
  props: {
    maquinarias: Array,
    proyectos: Array,
    conductores: Array,


  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        maquinaria_id: null,
        fecha: null,
        proyecto: null,
        operador: null,
        numero_comprobante: null,
        hora_fin: null,
        hora_inicio: '07:00',
        odometro_actual: null,
        observacion: null,
        feriado: 'NO',

      }),
    }
  },
  methods: {
    store() {
      this.form.post(this.route('reportemaquinaridiarios.store'))
    },
  },
}
</script>
